<template>
  <section class="section container pt-0">
    <billing-datatable />
  </section>
</template>

<script>
import BillingDatatable from "./billing_datatable/Index.vue";

export default {
  name: "FelIndex",
  components: {
    BillingDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
